export type Vehicle = {
    fuelType: string;
    emissionsData: number;
    environmentClass:string
  };
  
  export type EmissionsOutput = {
    field: string;
    name: string;
    percentage: number;
  };
  
  


  export function extractEmissionsData(vehiclesList: Vehicle[]): EmissionsOutput[] {
    const filteredVehicles = vehiclesList.filter((vehicle) => vehicle.emissionsData !== null);
    const totalVehicles = filteredVehicles.length;
    const environmentClassCount: Record<string, number> = {};
  
    filteredVehicles.forEach((vehicle) => {
      environmentClassCount[vehicle.environmentClass] = (environmentClassCount[vehicle.environmentClass] || 0) + 1;
    });
  
  
    return Object.entries(environmentClassCount).map(([environmentClass, count]) => ({
      field: `arcese_${environmentClass.toLowerCase().replace(/\s+/g, '_')}`, // Per sicurezza, sostituiamo gli spazi con "_"
      name: environmentClass,
      percentage: (count / totalVehicles) * 100,
    }));
  }
  

    

    export function extractFuelTypeData(vehiclesList: Vehicle[]): EmissionsOutput[] {
      const filteredVehicles = vehiclesList.filter((vehicle) => vehicle.fuelType !== null);
      const totalVehicles = filteredVehicles.length;
      const fuelTypeCount: Record<string, number> = {};
    
      filteredVehicles.forEach((vehicle) => {
        fuelTypeCount[vehicle.fuelType] = (fuelTypeCount[vehicle.fuelType] || 0) + 1;
      });
    
      return Object.entries(fuelTypeCount).map(([fuelType, count]) => ({
        field: `fuel_${fuelType.toLowerCase()}`,
        name: fuelType,
        percentage: (count / totalVehicles) * 100,
      }));
    }